

// export const membershipApplicationNames = [
//     { title: 'Life Members [lm] - INDIA & SAARC',slug: 'life-member' },
//     { title: 'International Life Members [ILM]',slug: 'international-life-member' },
//     { title: 'Associate Life Member [ALM]',slug: 'associate-life-member' },
//     { title: 'Associate Candidate Member [ACM]',slug: 'associate-candidate-member' },
//     { title: 'ALM to LM conversion',slug: 'alm-to-lm' },
//     { title: 'ACM to LM conversion',slug: 'acm-to-lm' },
// ];

export const membershipApplicationStatisticscardData = [
    { title: "Pending Actions", count: 4028, progress: 47 },
    { title: "All Applications", count: 4028, progress: 47 },
    { title: "Membership Number Allotted", count: 4028, progress: 47 },
    { title: "Pending Resubmission", count: 4028, progress: 47 },
    { title: "Pending Clarification", count: 4028, progress: 47 },
    { title: "Pending Payment", count: 4028, progress: 47 },
    { title: "Rejected", count: 4028, progress: 47 },
    { title: "Void", count: 4028, progress: 47 }
];

// export function convertDBDate(dateStr){    
//     const formattedDate = new Date(dateStr).toLocaleDateString("en-GB", {
//       day: "2-digit",
//       month: "2-digit",
//       year: "numeric",
//     });
//     return formattedDate;
//   }
export function convertDBDate(dateStr) {
  if (!dateStr) return "N/A";

  const date = new Date(dateStr);

  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "UTC"
  }).format(date);
}

//   export function convertCertificateDate(dateStr) {    
//   const date = new Date(dateStr);
//   const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
//   console.log(formattedDate);
//   return formattedDate;
// }

export function convertCertificateDate(dateStr) {
  if (!dateStr) return "N/A";

  const date = new Date(dateStr);
  const day = date.getUTCDate().toString().padStart(2, '0');
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0'); // UTC month is 0-based
  const year = date.getUTCFullYear();

  return `${day}-${month}-${year}`;
}
